import styles from "./styles.module.scss";
// import StarRatings from "react-star-ratings";
// import plusImg from "../../../assets/images/plus.png";
import notesImg from "../../../assets/images/notes.png";
import watchLaterImg from "../../../assets/images/watchLater.png";
// import likesImg from "../../../assets/images/likes.png";
// import likedImg from "../../../assets/images/liked.png";
import share from "../../../assets/images/share.png";
// import plusLightImg from "../../../assets/images/plusLight.png";
// import notesLightImg from "../../../assets/images/notesLight.png";
// import likesLightImg from "../../../assets/images/likesLight.png";
// import likedLightImg from "../../../assets/images/likedLight.png";
// import shareLight from "../../../assets/images/shareLight.png";

import { kFormatter, secondsToHms } from "../../../utils/common.utils";
import { useTheme } from "../../../contexts/ThemeContext/ThemeContext";
import {
  ContentType,
  LIKE_ACTION_TYPE,
  VideoType,
} from "../../../AppConstants/TypeConstants";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { LikeContext } from "../../../contexts/LikeContext/LikeContextProvider";
import { RatingContext } from "../../../contexts/RatingContext/RatingContextProvider";
import { UserContext } from "../../../contexts/UserContext/UserContextProvider";
import { AnalyticsContext } from "../../../contexts/Analytics/AnalyticsContextProvider";
import {
  VIDEO_DISLIKE_BTN_CLICK,
  VIDEO_LIKE_BTN_CLICK,
  VIDEO_RATING_CLICK,
} from "../../../AppConstants/AnalyticsEventName";
import {
  algoliaCustomEvents,
  AlgoliaEventType,
  algoliaIndices,
} from "../../../AppConstants/AlgoliaSearchConstants";
import CustomRating from "../../CustomRating";
import { ThumbIcon } from "../../../AppConstants/SvgIcon";
import { USER_INTERACTION_DEBOUNCE } from "../../../AppConstants/Constants";

function OverlayCardMob({
  startWatchingBtn,
  cardData,
  startingPoint,
  handleInviteBtn,
  handleNoteBtn,
  handleWatchLaterBtn,
  isWatchLaterVideo,
  handleShare,
}) {
  const { addGAWithUserInfo, SearchEvent } = useContext(AnalyticsContext);
  const { likeData, addLike, deleteLike } = useContext(LikeContext);
  const { ratingData, giveRating } = useContext(RatingContext);
  const { user } = useContext(UserContext);

  const likeTimerRef = useRef(null);

  const {
    type,
    category,
    title,
    parentCategory,
    description,
    likes,
    rating,
    seasons,
    videoType,
    duration,
    episode = undefined,
    season = undefined,
    tags,
  } = cardData;

  const hasStarted = (episode && season) ?? false;
  const { isDark } = useTheme();

  const videoLikeActionData = useMemo(() => {
    if (likeTimerRef.current) {
      clearTimeout(likeTimerRef.current);
      likeTimerRef.current = null;
    }
    if (likeData[cardData.id]) {
      return likeData[cardData.id].actionType
        ? likeData[cardData.id].actionType
        : LIKE_ACTION_TYPE.LIKE;
    } else {
      return null;
    }
  }, [likeData]);

  let isLiked = videoLikeActionData === LIKE_ACTION_TYPE.LIKE;
  let isDisliked = videoLikeActionData === LIKE_ACTION_TYPE.DISLIKE;

  const [__currentRating, setRating] = useState(
    ratingData[cardData.id] ? ratingData[cardData.id] : 0
  );

  const [_likes, setLike] = useState(likes);

  const performLikeAction = (btnType) => {
    if (likeTimerRef.current) {
      return;
    }
    switch (btnType) {
      case LIKE_ACTION_TYPE.LIKE:
        if (!user) {
          return;
        }
        addGAWithUserInfo(VIDEO_LIKE_BTN_CLICK, {
          count: likes,
          eventId: cardData.id,
        });
        SearchEvent(
          AlgoliaEventType.Conversion,
          algoliaIndices.videos,
          algoliaCustomEvents.conversion,
          [cardData.id]
        );
        if (isLiked) {
          setLike((prev) => prev - 1);
          deleteLike(cardData, ContentType.VIDEO, cardData.id);
        } else {
          setLike((prev) => prev + 1);
          addLike(cardData, ContentType.VIDEO, cardData.id);
        }
        break;
      case LIKE_ACTION_TYPE.DISLIKE:
        // dislike
        addGAWithUserInfo(VIDEO_DISLIKE_BTN_CLICK, { eventId: cardData.id });
        SearchEvent(
          AlgoliaEventType.Conversion,
          algoliaIndices.videos,
          algoliaCustomEvents.conversion,
          [cardData.id]
        );
        if (isDisliked) {
          deleteLike(cardData, ContentType.VIDEO, cardData.id, true);
        } else {
          if (isLiked) {
            setLike((prev) => prev - 1);
          }

          addLike(cardData, ContentType.VIDEO, cardData.id, true);
        }
        break;
      default:
        return;
    }
    likeTimerRef.current = setTimeout(() => {
      if (likeTimerRef.current) {
        clearTimeout(likeTimerRef.current);
        likeTimerRef.current = null;
      }
    }, USER_INTERACTION_DEBOUNCE);
  };

  useEffect(() => {
    setRating(ratingData[cardData.id] || 0);
    // setLike(likes);
  }, [cardData]);

  const giveUserRating = (userRate) => {
    addGAWithUserInfo(VIDEO_RATING_CLICK, {
      rating: rating,
      eventId: cardData.id,
    });
    SearchEvent(
      AlgoliaEventType.Conversion,
      algoliaIndices.videos,
      algoliaCustomEvents.conversion,
      [cardData.id]
    );
    giveRating(cardData, ContentType.VIDEO, cardData.id, userRate);
  };

  return (
    <div className={styles.overlayCardMob}>
      <div className={`${styles.row}`}>
        {tags
          .filter((t) => t !== "all_shows")
          .slice(0, 5)
          .map((entry, index) => {
            return (
              <div className={styles.tabs} key={index}>
                {entry.replaceAll("_", " ")}
              </div>
            );
          })}
      </div>
      <div className={`${styles.row} ${styles.infoRow}`}>
        <div>
          <div className={styles.title}>{title}</div>
          <div className={`${styles.row}`}>
            <div>{description}</div>
          </div>

          <div className={styles.subtitle}>{`${secondsToHms(duration)}`}</div>
        </div>
        {/* <div className={`${styles.row} ${styles.btnWrapper}`}>
          <img
            onClick={() => startWatchingBtn()}
            src={hasStarted ? continueWatching : startWatching}
            alt={hasStarted ? "Continue" : "Start"}
          />
        </div> */}
        {hasStarted ? (
          <div className={styles.progressInfo}>
            <div className={styles.durationBar}>
              <div
                className={styles.progressBar}
                style={{
                  width: `${
                    (startingPoint / duration) * 100 <= 100
                      ? (startingPoint / duration) * 100
                      : 100
                  }%`,
                }}
              />
            </div>
            <div className={styles.playedInfo}>
              {/* {secondsToHms(startingPoint)} of {secondsToHms(duration)} */}
              {secondsToHms(startingPoint)}
            </div>
          </div>
        ) : null}
        {user && (
          <div className={styles.rightInfo}>
            {/* <div className={`${styles.row} ${styles.socialData}`}>
            <img
              src={isDark ? plusImg : plusLightImg}
              alt="add"
              className={styles.actionImg}
            />
            <div>Add to list</div>
          </div> */}
            <div className={`${styles.row} ${styles.socialData}`}>
              <span
                onClick={() => performLikeAction(LIKE_ACTION_TYPE.LIKE)}
                className={styles.actionImg}
              >
                <ThumbIcon height={16} width={22} filled={isLiked} />
              </span>

              <div>{kFormatter(_likes)} Likes</div>
            </div>
            <div className={`${styles.row} ${styles.socialData}`}>
              <span
                className={styles.actionImg}
                onClick={() => performLikeAction(LIKE_ACTION_TYPE.DISLIKE)}
              >
                <ThumbIcon
                  height={16}
                  width={22}
                  filled={isDisliked}
                  isDislikeButton={true}
                />
              </span>

              <div> Dislike</div>
            </div>

            {user && (
              <div
                onClick={() => {
                  handleInviteBtn();
                  handleShare();
                }}
                className={`${styles.row} ${styles.socialData}`}
              >
                <img
                  // src={isDark ? share : shareLight}
                  src={share}
                  alt="share"
                  className={styles.actionImg}
                />
                <div>Share</div>
              </div>
            )}

            {user && (
              <div
                onClick={handleNoteBtn}
                className={`${styles.row} ${styles.socialData}`}
              >
                <img
                  // src={isDark ? notesImg : notesLightImg}
                  src={notesImg}
                  alt="notes"
                  className={styles.actionImg}
                />
                <div>My Notes</div>
              </div>
            )}

            {user && (
              <div
                onClick={handleWatchLaterBtn}
                className={`${styles.row} ${styles.socialData}`}
              >
                <img
                  src={watchLaterImg}
                  alt="watchLater"
                  className={styles.actionImg}
                  style={{
                    background: isWatchLaterVideo ? "#eb4547" : "transparent",
                    borderColor: isWatchLaterVideo ? "#eb4547" : "#fff",
                  }}
                />
                <div>Watch Later</div>
              </div>
            )}
          </div>
        )}

        {user && (
          <>
            <div style={{ fontSize: "0.9rem", marginBottom: "1rem" }}>
              Your Ratings
            </div>
            <div className={styles.AverageRatingWrapper}>
              <div className={`${styles.ratings}`}>
                <CustomRating
                  defaultRating={__currentRating}
                  giveRating={giveUserRating}
                  handleDefaultRating={setRating}
                />
              </div>
              {parseInt(rating) > 0 ? (
                <div className={styles.AverageRating}>{rating}</div>
              ) : null}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default OverlayCardMob;
